<template><p v-if="message" :id="id" class="lu-form-error">{{ message }}</p></template>
<script>export default {name:'UiFormError',props:{id:{type:String,required:true},message:{type:String,default:''}}};</script>
